<template>
  <div>
    <h1 class="common__main-title">Extra List</h1>
    <div>
      <Search
        @search="changeConditions"
        ref="search"
        class="mb-4"
      />
      <div class="pager-box">
        <PagerComponent v-model="pager" @changePage="fetchExtras" class="mb-2" />
      </div>
      <ExtraTable :extras="extras"/>
      <div class="pager-box">
        <PagerComponent v-model="pager" @changePage="fetchExtras" />
      </div>
    </div>
    <Loading :isLoading="isLoading"/>
  </div>
</template>

<script lang="ts">
import _ from 'lodash';
import { Component, Vue } from 'vue-property-decorator'
import { RootState } from '@/store/types';
import { Extra } from '@/store/extras/types';
import PagerComponent from '@/components/parts/Pager.vue';
import ExtraTable from '@/components/parts/extras/ExtraTable.vue';
import Search, { ExtraSearchConditions } from '@/components/parts/extras/ExtraSearch.vue';
import Loading from '@/components/parts/modal/Loading.vue';
import { Pager } from '@/store/pager.types';

@Component({
  components: {
    Search,
    PagerComponent,
    ExtraTable,
    Loading,
  },
})
export default class ExtrasComponent extends Vue {
    isLoading: boolean = false

    conditions: ExtraSearchConditions|null = null

    private get extras(): Extra[] {
      return (this.$store.state as RootState).extras.extras
    }

    private get pager(): Pager {
      return (this.$store.state as RootState).extras.pager
    }

    created() {
      this.fetchExtras()
    }

    /**
     * エクストラ一覧検索
     * @param {ExtraSearchConditions} searchConditions 検索条件
     */
    private changeConditions(searchConditions: ExtraSearchConditions) {
      this.conditions = searchConditions
      this.fetchExtras()
    }

    /**
     * エクストラ一覧取得
     * @param {number} page ページ番号
     */
    private fetchExtras(page: number = 1): void {
      if (this.isLoading) return
      this.isLoading = true

      this.$store.dispatch('fetchExtras', {
        page,
        conditions: this.conditions,
      })
        .finally(() => {
          this.isLoading = false;
        })
    }
}
</script>
